<template>
  <span class="scim-copy-badge">
    <span class="scim-copy-badge__text">{{ value }}</span>
    <button
      type="button"
      class="scim-copy-badge__button"
      :aria-label="`Copy ${value}`"
      @click="handleCopy"
    >
      <FontAwesomeIcon :icon="hasCopied ? ['fas', 'check'] : ['fak', 'copy']" />
    </button>
  </span>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { onBeforeUnmount, ref } from 'vue';

import { copyToClipBoard } from '@/utils';

const { value } = defineProps<{
  value: string;
}>();

const hasCopied = ref(false);
let copyTimer: ReturnType<typeof setTimeout> | null = null;

async function handleCopy() {
  await copyToClipBoard(value);
  hasCopied.value = true;
  copyTimer = setTimeout(() => {
    hasCopied.value = false;
  }, 1500);
}

onBeforeUnmount(() => {
  if (copyTimer) clearTimeout(copyTimer);
});
</script>

<style scoped lang="pcss">
@reference "../../../../css/theme.css";

.scim-copy-badge {
  @apply inline-flex items-center gap-6 bg-neutral-background-weak rounded px-8 py-4 font-mono text-xs text-neutral-text-strong max-w-full;
}

.scim-copy-badge__text {
  @apply truncate;
}

.scim-copy-badge__button {
  @apply text-neutral-text-placeholder hover:text-neutral-accent cursor-pointer shrink-0 transition-colors;
}
</style>
